const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ===== Pulse pack duo price fix (ajoute par Claude, theme de test) ===== */
/**
 * pack-price-fix.js  (Pulse Protein)
 * --------------------------------------------------------------------------
 * Corrige le prix du "pack duo" sur la page produit en fonction de la 2e saveur
 * choisie dans le dropdown. Met a jour A LA FOIS :
 *   - le bouton d'ajout au panier ([data-submit-price]) via le code existant,
 *   - la carte "Pack duo" (prix, prix barre, prix /portion) rendue en dur en Liquid.
 *
 * Bug d'origine : le prix duo est calcule a partir de valeurs figees (2x le prix
 * du produit principal) et ne tient pas compte de la 2e saveur. (L'ajout au panier
 * etait deja correct cote serveur.)
 *
 * Approche non destructive : on recalcule
 *   regulier  = prix_produit_principal + prix_2e_produit
 *   remise    = floor(regulier * pct / 100)      (pct = % deduit des valeurs initiales)
 *   /portion  = floor(floor(remise_total / portions) / 2)   (portions deduit de la carte simple)
 * et on reutilise le format monetaire du theme (deduit du texte deja affiche).
 */
(function () {
  function init() {
    var pack = document.querySelector('[data-product-pack]');
    if (!pack) return;

    var duoRadio = pack.querySelector('[data-pack-radio="duo"]');
    var dropdown = pack.querySelector('[data-pack-dropdown]');
    if (!duoRadio || !dropdown) return;

    var basePrice = parseInt(pack.dataset.productBasePrice, 10);
    if (isNaN(basePrice)) return;

    // Elements de la carte "Pack duo" (prix affiche en dur).
    var duoLabel = pack.querySelector('label[data-pack-type="duo"]');
    var cardPriceEl = duoLabel ? duoLabel.querySelector('.product-form-pack__option-price') : null;
    var cardOldEl = duoLabel ? duoLabel.querySelector('.product-form-pack__option-price-old') : null;
    var cardUnitEl = duoLabel ? duoLabel.querySelector('.product-form-pack__option-price-unit') : null;
    var simpleUnitEl = pack.querySelector('label[data-pack-type="simple"] .product-form-pack__option-price-unit');

    // % de remise duo (entier) deduit des valeurs initiales du radio.
    var initRegular = parseInt(duoRadio.dataset.priceOld, 10);
    var initDisc = parseInt(duoRadio.dataset.price, 10);
    var pct = (initRegular > 0 && initDisc > 0)
      ? Math.round((1 - initDisc / initRegular) * 100)
      : 0;

    // Nombre de portions par boite, deduit de la carte "Simple" (prix / prix par portion).
    var portions = 0;
    var simplePerPortion = simpleUnitEl ? parseCents(simpleUnitEl.textContent) : null;
    if (simplePerPortion && simplePerPortion > 0) {
      portions = Math.round(basePrice / simplePerPortion);
    }

    // Format monetaire deduit du texte deja rendu (ex: "€68,18").
    var fmt = buildFormatter(cardPriceEl ? cardPriceEl.textContent : '');

    var priceCache = {};
    var busy = false;

    function parseCents(text) {
      if (!text) return null;
      var m = String(text).match(/(\d+)[.,](\d{2})/);
      if (m) return parseInt(m[1], 10) * 100 + parseInt(m[2], 10);
      var m2 = String(text).match(/(\d+)/);
      return m2 ? parseInt(m2[1], 10) * 100 : null;
    }

    function buildFormatter(sample) {
      sample = (sample || '').trim();
      var prefix = '€', suffix = '', comma = true;
      var m = sample.match(/^(\D*)[\d.,\s]+(\D*)$/);
      if (m) { prefix = m[1] || ''; suffix = m[2] || ''; }
      if (sample) comma = sample.lastIndexOf(',') > sample.lastIndexOf('.');
      return function (cents) {
        var s = (cents / 100).toFixed(2);
        if (comma) s = s.replace('.', ',');
        return prefix + s + suffix;
      };
    }

    function fetchPrice(handle) {
      if (!handle) return Promise.resolve(null);
      if (priceCache[handle] != null) return Promise.resolve(priceCache[handle]);
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var price = (p && typeof p.price === 'number') ? p.price : null;
          if (price == null && p && p.variants && p.variants[0]) price = p.variants[0].price;
          if (price != null) priceCache[handle] = price;
          return price;
        })
        .catch(function () { return null; });
    }

    function activeHandle() {
      var active = dropdown.querySelector('.product-form-pack-dropdown__item--active');
      if (active && active.dataset.productHandle) return active.dataset.productHandle;
      if (dropdown.dataset.selectedProductHandle) return dropdown.dataset.selectedProductHandle;
      var first = dropdown.querySelector('[data-dropdown-item]:not([data-unavailable="true"])');
      return first ? first.dataset.productHandle : null;
    }

    function applySecondPrice(secondPrice) {
      var second = (secondPrice == null || isNaN(secondPrice)) ? basePrice : secondPrice;
      var regular = basePrice + second;
      // Remise tronquee (floor) = prix arrondi au centime SUPERIEUR, pour coller
      // au montant facture par le panier (qui arrondit le prix au superieur).
      var discounted = regular - Math.floor(regular * pct / 100);

      // Datasets lus par le code existant (bouton d'ajout au panier).
      duoRadio.dataset.priceOld = regular;
      duoRadio.dataset.price = discounted;

      // Carte "Pack duo" (affichage en dur).
      if (cardPriceEl) cardPriceEl.textContent = fmt(discounted);
      if (cardOldEl) cardOldEl.textContent = fmt(regular);
      if (cardUnitEl && portions > 0) {
        var perPortion = Math.floor(Math.floor(discounted / portions) / 2);
        cardUnitEl.textContent = fmt(perPortion) + ' /portion';
      }
    }

    function recompute(triggerDisplay) {
      return fetchPrice(activeHandle()).then(function (price) {
        applySecondPrice(price);
        if (triggerDisplay && duoRadio.checked) {
          busy = true;
          duoRadio.dispatchEvent(new Event('change', { bubbles: true }));
          busy = false;
        }
      });
    }

    // Pre-charge le prix de la saveur par defaut (corrige aussi la carte au chargement).
    recompute(false);

    // Changement de saveur -> recalcule carte + bouton si duo actif.
    dropdown.querySelectorAll('[data-dropdown-item]').forEach(function (item) {
      item.addEventListener('click', function () {
        if (item.dataset.unavailable === 'true') return;
        setTimeout(function () { recompute(true); }, 0);
      });
    });

    // Selection de l'option duo -> s'assure que le prix reflete la saveur courante.
    duoRadio.addEventListener('change', function () {
      if (busy) return;
      setTimeout(function () { recompute(true); }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
